<template>
    <div class="newStatus">
        <div class="newStatus_center">
            <bannerCenter
                    :box="box"
            ></bannerCenter>
            <div class="newStatus_thr">
                <div class="newStatus_thr_New">
                    <div class="newStatus_thr_left">
                        <div :class="item.isShow ? 'pageTopHide':'pageTopShow'" v-for="(item, index) in troList" :key="index" @click="isShowPage(item,index)">
                            <div class="xian"></div>
                            {{item.text}}
                        </div>
                    </div>
                    <div class="newStatus_thr_right" v-show="introduce">
                        <div class="newStatus_rightO">公司公告</div>
                        <div class="newStatus_thr_rightT">COMPANY ANNOUNCEMENT</div>
                        <div class="newStatus_thr_center" @click="clickMessage('message')">
                            <div class="left">
                                <div class="left_month">05</div>
                                <div class="left_date">2022/11</div>
                            </div>
                            <div class="right">
                                <div class="right_top">致所有合作伙伴的一封信</div>
                                <div class="right_center">11-05  尊敬的各位合作伙伴，我是逍遥推手CEO王爱军......</div>
                                <div class="right_bottom">查看详情<span>>>></span></div>
                            </div>
                        </div>
                        <div class="newStatus_thr_line"></div>
                        <div class="newStatus_thr_center" @click="clickMessage('notice')">
                            <div class="left">
                                <div class="left_month">31</div>
                                <div class="left_date">2022/10</div>
                            </div>
                            <div class="right">
                                <div class="right_top">金控-金逍遥重磅上线</div>
                                <div class="right_center">11-05  各位合作伙伴，逍遥推手又迎来了一个重大好消息......</div>
                                <div class="right_bottom">查看详情<span>>>></span></div>
                            </div>
                        </div>
                        <div class="newStatus_thr_line"></div>
                    </div>
                    <div class="newStatus_thr_right height" v-show="progress">
                        <div class="newStatus_rightO">公司新闻</div>
                        <div class="newStatus_thr_rightT">COMPANY NEWS</div>
                        <div class="newStatus_thr_progress">
                            <div class="pictrue"></div>
                            <div class="text">逍遥推手三周年庆典圆满落幕</div>
                            <div class="pictrue_one"></div>
                            <div class="text">逍遥推手黄埔一期大合影</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bannerCenter from '../../components/bannerCenter'
    export default {
        data(){
            return{
                troList:[
                    {
                        text:'公司公告',
                        isShow:true,
                    },
                    {
                        text:'公司新闻',
                        isShow:false,
                    }
                ],
                box:{
                    boxText:'',
                    boxTextWe:'',
                    boxTextEn:'NEWS INFORMATION'
                },
                introduce:true,
                progress:false,
                status:true,
                statusXin:false,
                statusGao:false,
                isShowNew:true,
                messageNotice:false
            }
        },
        components:{
            bannerCenter
        },
        methods:{
            isShowPage(item,index){
                for (let item in this.troList) {
                    this.troList[item].isShow = false
                }
                this.troList[index].isShow = true;
                if (index == 0){
                    this.introduce = true;
                    this.progress = false
                }
                if (index == 1){
                    this.progress = true;
                    this.introduce = false
                }
            },
            clickMessage(type){
                if (type == 'message'){
                    this.$router.push({
                        path:'/newStatus/companyAnnouncement'
                    })
                }
                if (type == 'notice'){
                    this.$router.push({
                        path:'/newStatus/jinKongAnnouncement'
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.newStatus{
    width: 100%;
    height: 100%;
    font-size: 13px;
    .newStatus_center{
        width: 100%;
        height: calc(100% - 62px);
        top: 62px;
        z-index: -1;

        .newStatus_thr{
            .newStatus_thr_New{
                width: 100%;
                flex: 1;
                background: #ffffff;
                display: flex;
                .newStatus_thr_left{
                    width: 91px;
                    background: #ffffff;
                    font-size: 11px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #1E1E1E;
                    padding: 29px 0 0 202px;
                    div:nth-child(1){
                        margin-bottom: 5px;
                        border-bottom: 0.5px solid #EDEDED;
                    }
                    .pageTopHide{
                        display: flex;
                        .xian{
                            width: 2px;
                            height: 15px;
                            background: #3E83FE;
                            margin-right: 9px;
                            border-radius: 2px;
                        }
                    }
                    .pageTopShow{
                        display: flex;
                        .xian{
                            width: 2px;
                            height: 15px;
                            background: #fff;
                            border-radius: 1px;
                            margin-right: 9px;
                        }
                    }
                }
                .newStatus_thr_right{
                    font-weight: 400;
                    font-size: 17px;
                    color: #1E1E1E;
                    font-family: Microsoft YaHei;
                    width: 565px;
                    padding: 11px 0 150px;
                    .newStatus_rightO{
                        text-align: center;
                    }
                    .newStatus_thr_rightT{
                        font-size: 11px;
                        font-weight: 300;
                        color: #3D3D3D;
                        margin-bottom: 28px;
                        text-align: center;
                    }
                    .newStatus_thr_rightF{
                        text-align: left;
                        text-indent:24px;
                        font-size: 12px;
                        margin-bottom: 10px;
                        line-height: 20px;
                    }
                    .newStatus_thr_progress{
                        /*margin: 0 auto;*/
                        margin-left: 10px;
                        text-align: center;
                        .pictrue{
                            width: 574px;
                            height: 287px;
                            background: url("./img/banner705.png") no-repeat;
                            background-size: 574px 287px;
                        }
                        .pictrue_one{
                            width: 574px;
                            height: 287px;
                            background: url("./img/banner706.png") no-repeat;
                            background-size: 574px 287px;
                        }
                        .text{
                            font-size: 22px;
                            font-family: "Microsoft YaHei";
                            font-weight: bold;
                            color: #000000;
                            margin: 23px 0;
                        }
                    }
                    .newStatus_thr_center{
                        margin-left: 11px;
                        display: flex;
                        align-items: center;
                        .left{
                            width: 77px;
                            height: 73px;
                            background: #3E83FE;
                            border-radius: 18px;
                            margin-right: 19px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: space-evenly;
                            .left_month{
                                font-size: 28px;
                                font-family: "Microsoft YaHei";
                                font-weight: bold;
                                color: rgba(255,255,255,0.9);
                            }
                            .left_date{
                                font-size: 14px;
                                font-weight: 400;
                                font-family: "Microsoft YaHei";
                                color: rgba(255,255,255,0.9);
                            }
                        }
                        .right{
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            .right_top{
                                font-size: 11px;
                                font-family: "Microsoft YaHei";
                                font-weight: bold;
                                color: #000000;
                            }
                            .right_center{
                                font-size: 10px;
                                font-family: "Microsoft YaHei";
                                font-weight: 300;
                                color: #424242;
                                margin: 9px 0 10px;
                            }
                            .right_bottom{
                                font-size: 11px;
                                font-family: "Microsoft YaHei";
                                font-weight: 300;
                                color: #FF0000;
                            }
                        }
                    }
                    .newStatus_thr_line{
                        width: 574px;
                        height: 0.01rem;
                        /*border: 1px solid #D8D8D8;*/
                        background: rgba(216,216,216,0.8);
                        margin: 11px 0;
                    }
                }
                .height{
                    padding-bottom: 48px !important;
                }
            }
        }
    }
}
</style>
